var map = {
	"./1ST.svg": "06fa",
	"./BCHABC.svg": "0212",
	"./BCHSV.svg": "c330",
	"./BETR.svg": "6c46",
	"./BTT.svg": "56ca",
	"./COFI.svg": "644a",
	"./DAI.svg": "9b76",
	"./DCC.svg": "17c6",
	"./DGTX.svg": "2606",
	"./DTH.svg": "ed7f",
	"./EDU.svg": "1f0f",
	"./EKO.svg": "a6a5",
	"./ELEC.svg": "7c0a",
	"./GIFTO.svg": "9029",
	"./INF.svg": "5a22",
	"./KCC.svg": "5300",
	"./LBA.svg": "1ad5",
	"./MAS (1).svg": "2ac0",
	"./MAS.svg": "36a4",
	"./MOC.svg": "00ab",
	"./MOT.svg": "69e1",
	"./NIM.svg": "b690",
	"./OCN.svg": "cf91",
	"./PAL.svg": "7f52",
	"./PAX.svg": "b6d1",
	"./PMA.svg": "ffcd",
	"./PRO.svg": "fcfd",
	"./PT.svg": "318d",
	"./QKC.svg": "bbcb",
	"./REN.svg": "6229",
	"./RFR.svg": "1e5d",
	"./SAI.svg": "f257",
	"./SNX.svg": "c723",
	"./SSP.svg": "fd9a",
	"./SUSD.svg": "48f0",
	"./TTC.svg": "d40e",
	"./WBTC.svg": "6a76",
	"./WETH.svg": "7627"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64d7";